/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersProfileBalanceMutationRequest, PostUsersProfileBalanceMutationResponse, PostUsersProfileBalance400 } from "../entities/PostUsersProfileBalance";

function getPostUsersProfileBalanceUrl() {
  const res = { method: 'POST', url: `/users/profile/balance` as const }  
  return res
}

/**
 * @description Пополнение баланса
 * @summary Пополнение баланса
 * {@link /users/profile/balance}
 */
export async function postUsersProfileBalance(data: PostUsersProfileBalanceMutationRequest, config: Partial<RequestConfig<PostUsersProfileBalanceMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostUsersProfileBalanceMutationResponse, ResponseErrorConfig<PostUsersProfileBalance400>, PostUsersProfileBalanceMutationRequest>({ method : "POST", url : getPostUsersProfileBalanceUrl().url.toString(), data : requestData, ... requestConfig })  
  return res.data
}